import axios from "axios";
import {TokenService} from "./token.services";

const APIService = {
    setHeader() {
        axios.defaults.headers.common['Authorization'] = `Bearer ${TokenService.getToken()}`;
        axios.defaults.headers.common['Session-ID'] = TokenService.getSessionID();
    },

    removeHeader() {
        axios.defaults.headers.common = {}
    }
}

export {APIService}
